import {Village} from "../../shared/interfaces/village";

export class MetricsRow {
  village?: Village;
  isTotalsRow: boolean;

  constructor(village?: Village, isTotalsRow: boolean = false) {
    this.village = village;
    this.isTotalsRow = isTotalsRow;
  }

  get rowKey(): string {
    return this.village?.id ?? "totals";
  }
}

export interface IMetricsSummary {
  villageIds?: string[];
}

/**
 * Represents a single column in the metrics table.
 * @remarks
 * @template TInput The type of the data that we will be using to calculate the value
 * @template TOutput The type of the data that we will be displaying
 */
export type MetricsColumn<
  TInput extends IMetricsSummary,
  TOutput extends MetricsRow
> = {
  /**
   * The name for the column. Must be unique
   */
  dataField: string;
  /**
   * The text that will be displayed in the table header
   */
  headerLabel: string;
  /**
   * The tooltip text, if null no tooltip will be rendered
   */
  tooltip?: string;
  /**
   * If the column is sortable
   */
  sort: boolean;
  /**
   * How do we calculate the value of this column
   * @param events The list of events for this row
   * @param dest The destination object where we should store the value
   */
  valueInit?: (data: TInput[], dest: TOutput) => void;
  /**
   * How do we format this column
   * @param data The data for this row
   */
  formatter: (data: TOutput) => string | number | boolean;
  /**
   * The raw value of this column, can be used for sorting
   * @param data The data for this row
   */
  rawValue: (data: TOutput) => string | number | boolean;
};

export type CalendarTypeOptions = "Enhanced" | "Engage" | "All";
export type MetricsTabOption = "Events" | "Updates";
